import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Animated } from "react-animated-css";
import InvertorsPower from '../../components/analytics/invertorspower';


import './Overview.css';

import {
        getUserStationList
} from '../../modules/analytics';

class Overview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:true
		}
	}

	async componentDidMount() {
		this.setState({loading:true});
                let stations = this.props.userStationList;
                if (!Array.isArray(stations) || stations.length === 0) {
                        await this.props.getUserStationList();
                }
		this.setState({loading:false});
	}

	async componentDidUpdate(prevProps) {


	}


	render() {
		const { loading } = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col md={24} lg={24} xl={24} xxl={24}>
								<Row>
									 <Col span={24}>
									 {!loading &&
										 <InvertorsPower/>
									 }
									</Col>
								</Row>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
        inspectionTime: state.analytics.inspectionTime,
        userStationList: state.analytics.userStationList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
                {
                        getUserStationList
                },
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
